module.exports = __webpack_public_path__ + "static/media/greatwall-final.fbca53d0.png";